import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function exportAdvancedSalesReportExcel(report, fileName = "sales-advanced-report.xlsx") {
  if (!report) return;

  const toRows = (obj, prefix = "") =>
    Object.entries(obj || {}).map(([k, v]) => ({
      [`${prefix}${k}`]: typeof v === "object" ? JSON.stringify(v) : v,
    }));

  const metaRows = toRows(report.meta, "meta.");
  const kpiRows = Object.entries(report.kpis || {}).map(([k, v]) => ({ KPI: k, Value: v }));
  const comparisonRows = [
    { Metric: "Current Period Amount", Value: report.comparison?.currentPeriodAmount ?? 0 },
    { Metric: "Previous Period Amount", Value: report.comparison?.previousPeriodAmount ?? 0 },
    { Metric: "Growth Amount %", Value: report.comparison?.growthAmountPct ?? null },
    { Metric: "Current Period Records", Value: report.comparison?.currentPeriodRecords ?? 0 },
    { Metric: "Previous Period Records", Value: report.comparison?.previousPeriodRecords ?? 0 },
    { Metric: "Growth Records %", Value: report.comparison?.growthRecordPct ?? null },
    { Metric: "Period Days", Value: report.comparison?.periodDays ?? null },
  ];

  const anomalyRows = Object.entries(report.anomalies || {}).map(([k, v]) => ({ Metric: k, Value: v }));
  const auditRows = Object.entries(report.audit || {}).map(([k, v]) => ({ Metric: k, Value: v }));

  const trendRows = (report.trend || []).map((r) => ({
    Bucket: r.key,
    Vouchers: r.records,
    Qty: r.qty,
    BillAmount: r.amount,
  }));

  const voucherBreakdownRows = (report.voucherBreakdown || []).map((r) => ({
    VoucherType: r.key,
    Vouchers: r.records,
    Qty: r.qty,
    BillAmount: r.amount,
  }));

  const topCustomersRows = (report.topCustomers || []).map((r) => ({
    Customer: r.key,
    Amount: r.amount,
    Records: r.records,
    Qty: r.qty,
  }));

  const topItemsRows = (report.topItems || []).map((r) => ({
    "Item/PartNo": r.key,
    Amount: r.amount,
    Records: r.records,
    Qty: r.qty,
  }));

  const topEmployeesRows = (report.topEmployees || []).map((r) => ({
    Employee: r.key,
    Amount: r.amount,
    Records: r.records,
    Qty: r.qty,
  }));

  const wb = XLSX.utils.book_new();

  const addSheet = (name, rows) => {
    const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [{ Empty: true }]);
    XLSX.utils.book_append_sheet(wb, ws, name);
  };

  addSheet("Meta", metaRows);
  addSheet("KPI", kpiRows);
  addSheet("Comparison", comparisonRows);
  addSheet("Trend", trendRows);
  addSheet("Voucher Breakdown", voucherBreakdownRows);
  addSheet("Top Customers", topCustomersRows);
  addSheet("Top Items", topItemsRows);
  addSheet("Top Employees", topEmployeesRows);
  addSheet("Anomalies", anomalyRows);
  addSheet("Audit", auditRows);

  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    fileName
  );
}

